<template>

  <div style="margin:0rem">
      

      <!--
  Lista elementi 
      -->
      <table class="tableSelectAc">
        
        <tr>
          <td colspan="2" style="border:none" class="tdChipGroup">
            <v-chip-group v-show="selectedAc.length>0"
            selected-class="text-primary"
            column class="chipGroup"
          >
            <v-chip close-icon="mdi-close" label close
              v-for="ac in selectedAc"
              :key="ac.prgAc"
              @click:close="removeAc(ac)"
            >
              {{ ac.specie+' '+ ac.des }}
            </v-chip>
          </v-chip-group>

          </td>
        </tr>
        <tr>

          <td>
            <div class="searchDiv1 tdWidth">
              
            <v-text-field
              clearable
              class="tdWidth"
              v-model="search"
              @change="queryForKeywords"
              placeholder="Digita il nome delle via"
              id="searchInput"
            />
          </div>
          </td>
          <td>
            <paginator ref="ref_paginator"
         eager
         :currentPage="paginator.currentPage"
         :recordCount="filteredList.length"
          @setCurrentPage="setCurrentPage"
                    ></paginator>
          </td>

        </tr>
        <tr v-for="via in getPage()"
          v-bind:key="via.prgAc">
        <td class="tdAc">
          <span class="tdWidth">{{ via.fullDes }}</span>

        </td>
        <td class="tdSelect">
          <v-btn
          color="pink_"
          class="btnSeleziona"
          dark
          small
          @click="selectAc(via)"
          
        >
          Seleziona 

          
        </v-btn>
        </td>
        </tr>

      </table>
        
    
      </div>
</template>
  <script>
import { router } from "../main.js";
import itemTemplate from "../components/item-template.vue";
import { userService } from "../services/userServices.js";

export default {
  props:
        {
     selectedAc:{type: Array,
        required:true }
        
     },
  data: () => ({
    
    
    
    showTotItems: true,
    totItems: 0,
    snackBarTimeout: 4000,
    openList: false,
    itemTemplate,
    show: true,
    paginator:{
                currentPage:1,
            pageSize:10,
            
            },
      
    onError: false,
    currentlyActiveField: null,
    testoInserimento: "",
    debug: "not",
    listaAc: [],
    lista: {},
    search: "",
    maxResult: 11000,
    hasMore: false,
    lastComune:'xx?'
  }),
  computed: {
   
    filteredList() {
     // console.log('serache:'+this.search);
      var list= this.listaAc
        .filter((post) => {
          return (
            
              this.search==null || this.search.length < 1 ||
            post.des.toLowerCase().includes(this.search.toLowerCase())
          );
        });
        return list;
        
        
    },
  },
  created() {
    this.$vuetify.theme.dark = true;
  },
  activated() {
    var comune=userService.getCurrentComune();
    if (comune != this.lastComune){
      this.retrieveListaVie();
    }
    
  },
  mounted() {},
  methods: {
     compare( a, b ) {
  if ( a.des < b.des ){
    return -1;
  }
  if ( a.specie < b.specie ){
    return -1;
  }
  return 0;
},
    removeAc(ac){
      this.listaAc.push(ac);
      this.listaAc.sort(this.compare);
      const index = this.selectedAc.indexOf(ac);
      this.selectedAc.splice(index,1);
    },
    selectAc(ac){
      this.selectedAc.push(ac);
      const index = this.listaAc.indexOf(ac);
      this.listaAc.splice(index,1);
    },
    getPage(){
      var initIndex=this.paginator.pageSize*(this.paginator.currentPage -1);
        if (initIndex >= this.filteredList.length){
          initIndex=0;
        }  
        var endIndex=initIndex+this.paginator.pageSize;
        if (endIndex >=this.filteredList.length){
          endIndex=this.filteredList.length;
        }
        var list=this.filteredList.slice(initIndex,endIndex);
       
        //console.log("InitIndex,EndIndex:"+initIndex+','+endIndex+','+this.filteredList.length);
        return list;

    },
    
    setCurrentPage(page){
            //this.$refs.ref_paginator.currentpageChanged(page);
            this.paginator.currentPage=page;
            
        },
    queryForKeywords() {
      
        this.paginator.currentPage=1;

//      const value = event.target.value;
      //      alert(JSON.stringify(value));
  //    this.search = value;
      if (this.hasMore) {
        //rifaccio retrieve, ce ne sono altri
        this.retrieveListaVie();
      }
    },
    onKeyEnter(text) {
      this.testoInserimento = text;
      alert(text);
      var catId = "ALTRO";
      var catIcon = "altro.png";

      const item = { text, catId, catIcon };
      this.add(item);
    },

    retrieveListaVie() {
      userService.getListaAc('', this.maxResult).then((x) => {
        //array degli items
        //this.lista.items.splice(0, this.lista.items.length);
        this.listaAc = x;
        this.lastComune=userService.getCurrentComune();
        /*for (let index = 0; index < x.length; index++) {
            const item = x[index];
            item.deleted = false;
            this.listaAc.push(item);
          }*/

        this.totItems = this.listaAc.length;
        if (this.totItems === this.maxResult) {
          this.hasMore = true;
        } else {
          this.hasMore = false;
        }
        
      });
    },
    onItemChanged(text) {
      this.testoInserimento = text;
      alert(this.search);
    },
    onItemSelected(item) {
      this.testoInserimento = item.text;
      this.add(item);
    },
    clickOnVia(via) {
      const p = "/dettaglioAc/" + via.prgAc;

      router.push({ path: p });
    },
    retrieveAvailableItems() {
      userService.getAvItems(this.lista.listId).then((x) => {
        //array degli available items
        this.availableItems.splice(0, this.availableItems.length);
        for (let index = 0; index < x.length; index++) {
          const item = x[index];
          this.availableItems.push(item);
        }
      });
    },
  },
};
</script>
                     <style lang="css" scoped>
.bounce-leave-active {
  animation: bounce-out 0.7s;
}
.bounce-enter-active {
  animation: bounce-out 0.7s reverse;
}
.bounce-enter {
  animation: bounce-out 0.7s reverse;
}
@keyframes bounce-out {
  100% {
    transform: translateX(100%);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

#searchInput {
  
  width: 100%;
  min-width: 30rem;
  padding: 1rem;
}
.searchDiv {
  border: 0px solid rgb(132, 132, 129);
}
.rigaItem {
  max-height: 2.2rem;
}
.tableSelectAc{
  border-collapse: collapse; 
}
.tdAc{
  width: 23rem;
  min-width: 30rem;
}
.tableSelectAc td{
  border: 1px solid gray;
  padding: 0.5rem;
}
.chipGroup{
  border: 1px solid gray;
  border-radius: 12px;
  padding: 4px;
  min-height: 4rem;
  min-width: 21rem;
  width: 45rem;
  margin: 0;
  max-width: 48.5rem;
}
.tdWidth{
  width:35rem;
  min-width: 35rem;

}.btnAll {
  width:8rem;
  float: right;
}
td.tdChipGroup{

  padding-left: 0 !important;;
  padding-right: 0 !important;;
}

</style>